import { Mark } from '@tiptap/pm/model';
import { webSafeFonts } from '../../../components/Editor/constants';
const allowedFonts = Object.values(webSafeFonts);

export const cleanMark = (mark: Mark): Record<string, any> => {
  if (mark.type.name !== 'fontFamily') {
    return {};
  }

  if (allowedFonts.includes(mark.attrs['fontFamily'])) {
    return {
      fontFamily: mark.attrs['fontFamily'],
    };
  }

  return {};
};
